import intlTelInput from 'intl-tel-input';

window.intlTelInput = intlTelInput;

export default function initIntlTelInput() {
  const elements = document.querySelectorAll('.intl-tel-input');

  elements.forEach((el) => {
    const $el = jQuery(el);
    const iti = intlTelInput(el, {
      separateDialCode: true,
      // nationalMode: false,
      strictMode: true,
      autoPlaceholder: false,
      // loadUtils: () => import("intl-tel-input/utils"), // Moved below
      hiddenInput: (telInputName) => ({
        phone: telInputName + "[phone]",
        country: telInputName + "[country]",
      }),
    });

    $el.change(() => {
      const isValid = iti.isValidNumber();
      const number = iti.getNumber();
      const error = iti.getValidationError();

      // Update the hidden input on change, not just on submit.
      if (iti.hiddenInput) {
        if (number) {
          jQuery(iti.hiddenInput).val(number);
        } else if ($el.val() === '') {
          jQuery(iti.hiddenInput).val('');
        }
      }

      // Apply the error styles
      if (isValid
        || error === 0 /* intlTelInput status "is possible" */
        || error === -99 /* Internal intlTelInput error */
      ) {
        $el.removeClass('is-invalid');
      } else {
        $el.addClass('is-invalid');
      }
    });

    // Initialize the hidden field with the initial value
    if (iti.hiddenInput) {
      jQuery(iti.hiddenInput).val($el.val());
    }

    $el.trigger('change');
  });

  // Load the utils portion of the library and trigger the change event afterwards.
  if (elements.length > 0) {
    const loadUtils = () => import("intl-tel-input/utils");
    intlTelInput
      .attachUtils(loadUtils)
      .then(() => {
        elements.forEach((el) => {
          jQuery(el).trigger('change');
        });
      });
  }
}
